import { createContext } from 'react';
import { GetAccountsPositionsParams } from '@goldwasserexchange/actor/rest-services';

export const accountsPositionsParamsContext = createContext<Partial<GetAccountsPositionsParams>>({});
